import isObject from 'lodash/isObject'

/**
 * @param {Object|null} file
 * @return string
 */
export function fileObjectUrl(file) {
  if (!file || !isObject(file)) {
    return ''
  }

  const isExternalFile = (file.location || '') === 'external'
  if (isExternalFile) {
    return file.url || ''
  }

  const path = file.path || ''
  if (!path) {
    return ''
  }

  return window.APP.context.site.files_url + path
}

/**
 * @param {Object|null} file
 * @return string
 */
export function thumbUrlFromFileObject(file) {
  if (!file || !isObject(file)) {
    return ''
  }

  if ('coverPhoto' in file) {
    return fileObjectUrl(file.coverPhoto)
  }

  if ((file.location || '') === 'external') {
    // Fetching thumbnail of external resource (image or video) not implemented.
    return ''
  }

  if (!file.filename) {
    return ''
  }

  return `${window.APP.context.site.files_url + (file.dir || '')}_thumb/${file.filename}`
}
